import { Box, Toolbar, Typography } from '@mui/material'
import { useLanguage } from '../context/LanguageContext';
import tobaco1 from '../Image/tobaco.jpeg'
import oral1 from '../Image/oral.jpg'
import tissue1 from '../Image/tissue.jpeg'
import React from 'react'

const Awareness = () => {
    const { t } = useLanguage();
  return (
    <Box>
        <Toolbar>
            <div className='awareness-Screen'>
                <div className='awareness-banner'>
                    <Typography variant='h2'>{t('aw_title')}</Typography>
                </div>
                
                <div className='awarenessWrapper'>
                    <div className='areness-img'>
                            <img src={tobaco1} alt="" />
                    </div>
                    <div className='awareness-content'>
                        <Typography variant='h3'>{t('aw_t_one')}</Typography>
                        <Typography variant='h4'>{t('aw_sb_one')}</Typography>
                        <Typography variant='body1'>{t('aw_p_one')}</Typography>
                    </div>
                </div>
               <div className='awarenessWrapper reverse'>
                    <div className='awareness-content'>
                        <Typography variant='h3'>{t('aw_t_two')}</Typography>
                        <Typography variant='h4'>{t('aw_sb_two')}</Typography>
                        <Typography variant='body1'>{t('aw_p_two')}</Typography>
                    </div>
                    <div className='areness-img'>
                            <img src={oral1} alt="" />
                    </div>
                </div>
                <div className='awarenessWrapper'>
                    <div className='areness-img'>
                            <img src={tissue1} alt="" />
                    </div>
                    <div className='awareness-content'>
                        <Typography variant='h3'>{t('aw_t_three')}</Typography>
                        <Typography variant='h4'>{t('aw_sb_three')}</Typography>
                        <Typography variant='body1'>{t('aw_p_three')}</Typography>
                    </div>
                    
                </div>
            </div>
        </Toolbar>
    </Box>
  )
}

export default Awareness
